import { useApiClient } from './ApiClient';

const endpoint = import.meta.env.VITE_APP_GW_URL;
const systemId = import.meta.env.VITE_APP_SYSTEMID;

const { get, post, del } = useApiClient();

// ==================== 내 사주 API ====================

/** '내 사주' 그룹 내 목록 조회 API */
export const getMySajuGroupAPI = async (params) => {
  const { data } = await get(`${endpoint}/users/groupGuestUsers/mySajuGroup`, params);
  return data;
};

/** '내 사주' 저장 API */
export const setMySajuAPI = async (params) => {
  const { data } = await post(`${endpoint}/users/groupGuestUsers/my`, params);
  return data;
};

/** '내 사주' 목록 정보 조회 */
export const getMySajuAPI = async (params) => {
  const { data } = await get(`${endpoint}/users/groupGuestUsers/my`, params);
  return data;
};

/** '내 사주' 상세 정보 */
export const getMySajuDetailAPI = async ({ guestUserId, params }) => {
  const { data } = await get(`${endpoint}/users/groupGuestUsers/my/${guestUserId}`, params);
  return data;
};

/** 내 사주 삭제 API - 개발용 */
export const deleteMySajuAPI = async (params) => {
  const { data } = await del(`${endpoint}/users/groupGuestUsers/my`, params);
  return data;
};

// ==================== 일진달력 API ====================

/** 일진달력 월 조회 API */
export const getDailyFortuneCalendarAPI = async (body) => {
  const params = body ? new URLSearchParams(clarify(body)) : {};
  const response = await get(`/fast/daily-fortune-calendar`, params);
  return response?.data;
};

/** 회원이 조회 가능한 일진달력 확인 */
export const getDailyFortuneCheckAPI = async () => {
  const response = await get(`/fast/daily-fortune-calendar/check`, {});
  return response?.data;
};

/** 일진달력 날짜 조회 API (상세조회) */
export const getDailyFortuneDetailAPI = async (params) => {
  const { data } = await get(`/fast/daily-fortune-calendar/detail`, params);
  return data;
};

/** 일진달력 카테고리 조회 API */
export const getDailyCategoryAPI = async (params) => {
  const { data } = await get(`/fast/daily-fortune-calendar/category`, params);
  return data;
};

/** 일진달력 조회하기 포인트 사용 API */
export const purchaseDailyFortuneAPI = async (params) => {
  const response = await post(`${endpoint}/fast/daily-fortune-calendar/purchase`, params);
  return response;
};

/** 일진달력 카테고리 포인트 사용 API */
export const purchaseDailyCategoryAPI = async (params) => {
  const response = await post(`${endpoint}/fast/daily-fortune-calendar/category/purchase`, params);
  return response;
};

/** 일진달력 포인트 가격 조회 */
export const getDailyFortunePriceAPI = async () => {
  const { data } = await get(`${endpoint}/fast/daily-fortune-calendar/price`, {});
  return data;
};

/** 일진달력 카테고리 조회 API */
export const getDailyCategoryDetailAPI = async (params) => {
  const { data } = await get(`${endpoint}/fast/daily-fortune-calendar/category/detail`, params);
  return data;
};

/** 일진달력 카테고리 상태 조회 API */
export const getDailyCategoryStatusAPI = async (params) => {
  const response = await get(`${endpoint}/fast/daily-fortune-calendar/category/status`, params);
  return response?.data;
};

/** 일진달력 > 회원이 무료조회 가능한 총 카테고리 수 */
export const getDailyCategoryFreeCountAPI = async (params) => {
  const { data } = await get(
    `${endpoint}/fast/daily-fortune-calendar/category/total-count`,
    params,
  );
  return data;
};

/**
 * 일진보기 > 평가 조회 API
 * - objectKey: {guest_user_id}_{YYYY-MM-DD} 형식
 */
export const getDailyFortuneRateAPI = async (params) => {
  const response = await get(`${endpoint}/rate`, params);
  return response.data;
};

/**
 * 일진보기 > 평가하기 전송 API
 * - objectKey: {guest_user_id}_{YYYY-MM-DD} 형식
 */
export const postDailyFortuneRateAPI = async (params) => {
  const response = await post(`${endpoint}/rate`, params);
  return response;
};

/** 앱 무료일진 조회 API */
export const getDailyFortuneSummaryAPI = async (params) => {
  const response = await get(`/func_luck_details_ext/life-summary`, params);
  return response.data;
};

// ========== 역학달력 API ==========

/** 역학달력 정보 요청 API */
export const getSajuCalendarAPI = async (body) => {
  const params = body ? new URLSearchParams(clarify(body)) : {};
  const { data } = await get(`${endpoint}/fast/sajuCalendar/`, params);
  return data;
};

/**
 * 택일(Choice) 결제 및 로그 생성 API
 * POST /analysis/log (가칭 Endpoint, 실제 엔드포인트 확인 필요 시 수정)
 * 하지만 일단 기존 PopAnalysisInfoOther에서 쓰던 /analysis/log 와 동일한 구조로 가정하고 작성
 * 혹은 /fast/choice/purchase 등의 별도 엔드포인트일 수도 있음.
 * 일단 요구사항에 따라 '새로 택일 전용으로 하나 더 만들자'고 하여,
 * 기능적으로는 postAnalysisLogAPI와 유사하게 작성함.
 */
export const postChoiceLogAPI = async (params) => {
  // TODO: 실제 백엔드 엔드포인트 확인 필요. 일단 /analysis/log 로 유지하거나
  // 택일 전용 엔드포인트가 있다면 변경해야 함.
  let path = `/analysis/log`;
  const data = await post(path, params);
  return data;
};

/**
 * 단일(1일) 집중 분석 결과 조회 API
 * @param {Object} params - { guestUserId, year, month, day, category }
 * @returns {Promise<Array>} - 분석 결과 배열 (단일 모드)
 */
export const getChoiceFocusDetailAPI = async (params) => {
  const { guestUserId, year, month, day, category } = params;
  const queryParams = {
    guestUserId: String(guestUserId),
    analysisTypeId: '13',
    year: String(year),
    month: String(month),
    day: String(day),
    category,
  };
  const { data } = await get('/fast/base-service', queryParams);
  return data;
};

/**
 * 구간(주간/월간) 분석 결과 조회 API
 * @param {Object} params - { guestUserId, year, month, day?, category }
 *   - day가 없으면: 해당 월 전체 데이터 조회 (달력 표시용)
 *   - day가 있으면: 해당 날짜에 구매한 데이터 조회 (팝업 표시용)
 * @returns {Promise<Object>} - 분석 결과 객체 (구간 모드)
 */
/**
 * [Best Day] 이달의 추천일 조회 API
 * @param {Object} params - { guestUserId, year, month }
 * @returns {Promise<Object>} - { 이달의베스트: { 날짜키, 활동, 확률, 한줄요약, ... } }
 */
export const getBestDayAPI = async (params) => {
  const { guestUserId, year, month } = params;
  const queryParams = {
    guestUserId: String(guestUserId),
    suggestionFlag: '1',
    analysisTypeId: '14',
    year: String(year),
    month: String(month),
  };
  const { data } = await get('/fast/base-service', queryParams);
  return data;
};

export const getChoiceRangeDetailAPI = async (params) => {
  const { guestUserId, year, month, day, category } = params;
  const queryParams = {
    guestUserId: String(guestUserId),
    analysisTypeId: '14',
    year: String(year),
    month: String(month),
    category,
  };
  // day가 있는 경우에만 추가 (월 전체 데이터 조회 시에는 day 없음)
  if (day !== undefined && day !== null) {
    queryParams.day = String(day);
  }
  const { data } = await get('/fast/base-service', queryParams);
  return data;
};
